<script setup></script>
<template>
    <h4 class="text-xl font-bold">
        <slot></slot>
    </h4>
</template>
